<template>
  <ProductPay/>
</template>
<script>
import ProductPay from 'place/pay/productPay.vue'
export default {
    components:{
      ProductPay
    }
}
</script>